import React, {useState, useEffect, useRef} from 'react';
import styled from 'styled-components';
import ThreeFlyingDots from '../../styles/assets/three_flying_dots.svg';

import SeedPhraseLink from '../../styles/assets/seed_link_menu.svg';
import DollarIcon from '../../styles/assets/dollar.svg';
import DollarWhiteIcon from '../../styles/assets/dollar_white.svg';
import RupeeIcon from '../../styles/assets/rupees.svg';
import ScanQRIcon from '../../styles/assets/scan_qr_icon.svg';
import LogoutIcon from '../../styles/assets/red_logout_icon.svg';
import blue_tick from '../../styles/assets/blue_tick.svg';
import { openDeeplink } from '../../services/androidCallback';
import { eventTracker } from '../../services/eventTracker';

import { useTranslation } from "react-i18next";

const DropDownDiv = styled.div`
    position: relative;
    display: inline-block;  
`

const DropdownContentContainerDiv = styled.div`
    position: absolute;
    min-width: 200px;
    background: #141624;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.08), 0px 8px 8px rgba(0, 0, 0, 0.16);
    border-radius: 12px;
    z-index: 1;
    right: 0px;
    top: 36px;
`

const DropdownContentDivWrapper = styled.div`  
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 16px;
`

const DropdownContentDiv = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.1px;
    color: #FFFFFF;
    padding: 12px 16px;
    display: flex;
    justify-content: start;
    align-items: center;
`

const DropdownButtonDiv = styled.div`
    background: #1C1F33;
    border-radius: 100px;
    width: 87px;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
`

const DropdownButtonTextSpan = styled.span`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 16px;
    color: #FFFFFF;
`;

const Title = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.1px;
    color: #FFFFFF;
    padding: 12px 0px;
`;

interface IButtonProps {
    active: boolean;
}

const BlueButton = styled.div<IButtonProps>`
    background: ${props => props.active ? 'linear-gradient(90.07deg, #3999F9 29.06%, #4A7DFF 96.96%)' : '#1C1F33'};
    border-radius: 8px;
    display: flex;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.1px;
    color: #FFFFFF;
    padding: 12px;
    justify-content: center;
    align-content: center;
`;

const Input = styled.input`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    padding: 12px;
    background: transparent;
    color: #fff;
    border: none;
    width: 160px;
`;

function useOutsideAlerter(ref:any, setOpen:any) {
    useEffect(() => {
        function handleClickOutside(event:any) {
            if (ref.current && !ref.current.contains(event.target)) {
                setOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
}

const UserWalletOptionMenuComponent = (props: any)=>{

    const [showMenu, setShowMenu] = useState(false);
    const [showCurrencyMenu, setShowCurrencyMenu] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [url, setUrl] = useState('');
    const [isWaypoint, setIsWaypoint] = useState(false);
    
    const  {t} = useTranslation();
    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef, setShowMenu);
    
    //handle click of menu button
    const handleClickMenu = () => setShowMenu(!showMenu);


    useEffect(() => {
        const walletType = localStorage.getItem('gw-wallet-type');
        setIsWaypoint(walletType === 'RoninWaypoint');
        setShowCurrencyMenu(false);
    }, [showMenu])
    
    const scanQRClick = () => {
      handleClickMenu();
      openDeeplink('https://glip.gg/walletconnect')
    }

    const isIos = (window as any).ios? true: false;
    return (
      <>
        <DropDownDiv ref={wrapperRef}>
          <DropdownButtonDiv className='hover' onClick={handleClickMenu}>
            <DropdownButtonTextSpan>{t('More')}</DropdownButtonTextSpan>
            <img src={ThreeFlyingDots} style={{marginLeft:7}} alt='' />
          </DropdownButtonDiv>
          {showMenu && !showCurrencyMenu &&(
              <DropdownContentContainerDiv>
                    {!isWaypoint && (
                            <DropdownContentDiv onClick={() => {
                                props.showSeedPhraseClicked();
                                eventTracker('show_seed_phrase_click', props);
                            }}>
                                <div style={{display: 'flex'}}>
                                    <img style={{marginRight: 18}} src={SeedPhraseLink} alt=''/>
                                </div>
                                <div>{t('Seed phrase')}</div>
                            </DropdownContentDiv>
                        )}
                <DropdownContentDiv className='hover' onClick={() => setShowCurrencyMenu(true)}>
                  <div style={{display: 'flex'}}>
                    <img style={{marginRight: 24}} src={DollarIcon} alt='' />
                  </div>
                  <div>{t('Select currency')}</div>
                </DropdownContentDiv>

                {(window as any).javascript_obj && !isIos && <DropdownContentDiv className='hover' onClick={()=>{
                    setShowModal(true);
                    eventTracker('open_browser_clicked', props);
                  }}>

                    <div style={{display: 'flex'}}>
                      <img style={{marginRight: 15}} src={SeedPhraseLink} alt=''/>
                    </div>
                    <div>{t('open_browser')}</div>
                  </DropdownContentDiv>
                }

                {(!isIos) && (
                <DropdownContentDiv className='hover' onClick={() => {
                    scanQRClick();
                    eventTracker('scanQR_clicked', props);
                }}>
                  <div style={{display: 'flex'}}>
                    <img style={{marginRight: 14}} src={ScanQRIcon} />
                  </div>
                  <div>{t('Scan QR Code')}</div>
                </DropdownContentDiv>
                )}
              {(!isIos) && (
                  <DropdownContentDiv className='hover' onClick={()=>{
                      props.logoutClicked();
                    eventTracker('logout_clicked', props);
                  }}>

                    <div style={{display: 'flex'}}>
                      <img style={{marginRight: 15}} src={LogoutIcon} alt=''/>
                    </div>
                    <div>{t('Logout')}</div>
                  </DropdownContentDiv>                  
              )}              
              </DropdownContentContainerDiv>
          )}
        {showMenu && showCurrencyMenu &&(
                  <DropdownContentContainerDiv className='hover'>              
                    <DropdownContentDivWrapper className='hover'>
                      <DropdownContentDiv className='hover' onClick={() => {
                          props.changeCurrency('USD');
                          setShowCurrencyMenu(false);
                          setShowMenu(false);
                          eventTracker('currency_change', {currency: 'USD'});
                      }}>
                        <div style={{display: 'flex'}}>
                          <img style={{marginRight: 15}} src={DollarWhiteIcon} alt='' />
                        </div>
                        <div>{t('Dollars')}</div>
                      </DropdownContentDiv>
                      {props.activeCurrency === 'USD' && (<img src={blue_tick} alt='' />)}
                    </DropdownContentDivWrapper>
                    
                    <DropdownContentDivWrapper className='hover'>
                      <DropdownContentDiv className='hover' onClick={() => {
                          props.changeCurrency('INR');
                          setShowCurrencyMenu(false);
                          setShowMenu(false);
                          eventTracker('currency_change', {currency: 'INR'});
                      }
                      }>
                        <div style={{display: 'flex'}}>
                          <img style={{marginRight: 15}} src={RupeeIcon} alt='' />
                        </div>
                        <div>{t('Rupees')} (INR)</div>
                      </DropdownContentDiv>
                      {props.activeCurrency === 'INR' && (<img src={blue_tick} alt='' />)}
                    </DropdownContentDivWrapper>
                    <DropdownContentDivWrapper className='hover'>
                      <DropdownContentDiv className='hover' onClick={() => {
                          props.changeCurrency('BRL');
                          setShowCurrencyMenu(false);
                          setShowMenu(false);
                          eventTracker('currency_change', {currency: 'BRL'});
                      }
                      }>
                        <div style={{display: 'flex'}}>
                          <span style={{marginRight: 15}}>
                            R$
                          </span>
                        </div>
                        <div>{t('Real')} (BRL)</div>
                      </DropdownContentDiv>
                      {props.activeCurrency === 'BRL' && (<img src={blue_tick} alt='' />)}
                    </DropdownContentDivWrapper>
                  </DropdownContentContainerDiv>
              )}
              
        </DropDownDiv>
        {showModal && (
          <>
            {/* <div 
              onClick={() => setShowModal(false)} 
              style={{height: '100%', width:'100%', position: 'absolute', bottom: 0, top: 0, left: 0, right: 0, background: 'rgba(0,0,0,0.3)', zIndex: 111}}>                
            </div> */}

            <div        
              onClick={() => setShowModal(false)}       
              style={{height: '100%', width:'100%', position: 'absolute', bottom: 0, top: 0, left: 0, right: 0, background: 'rgba(0,0,0,0.0)', zIndex: 111}}>                            
              <div style={{position: 'relative', zIndex: 112, display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'}}>
                <div onClick={(e) => {e.stopPropagation()}}  style={{padding: '16px 52px', background: '#141624', borderRadius: 8}}>
                  <Title>Enter URL</Title>
                  <Input placeholder='https://example.com/...' style={{marginBottom: 12, border: '1px solid grey', borderRadius: 8}} type="text" onChange={(e) => setUrl(e.target.value)} />
                  <BlueButton active={url.length>0} onClick={() => {                      
                    if(url.length > 0) {
                      openDeeplink(`glipwallet://open_url?url=${url}`)
                      setShowModal(false);                      
                    }
                  }}>Open URL</BlueButton>
                </div>
              </div>
            </div>
          </>)}
          </>
          );
}

export default UserWalletOptionMenuComponent;
